import React from 'react';
import Tab from './Tab'
import Watch from './WatchPoint';
import Add from './AddPoint'

const Points = (props) => {
  const { state } = props
  return (
    <>
      <div style={{ minHeight: '205px' }}>
        <div className='modal-title-header'>
          <div className='title-modal-kml-input no-select'>Agregar Puntos</div>
          <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={props.close}></i></div>
        </div>
        <div className="points-content">
          <Tab active={state.pestana === 'ver'} icon='fas fa-binoculars' iconType='FA' title='Ver' click={props.selectTab} />
          <Tab active={state.pestana === 'agregar'} icon='fas fa-plus' iconType='FA' title='Agregar' click={props.selectTab} />
        </div>
        <div className='points-spacework'>
          {
            state.pestana === 'ver' ?
              <Watch
                state={props.state}
                activePunto={props.activePunto}
                activeAllPuntos={props.activeAllPuntos}
                handlerDobleClick={props.handlerDobleClick}
                accept={props.updatePoint}
                cancel={props.cancelPoint}
                delete={props.deletePoint}
              /> :
              <Add
                state={props.state}
                changeAddSelect={props.changeAddSelect}
                handlerTextPunto={props.handlerTextPunto}
                selectPointOnMap={props.selectPointOnMap}
                savePoint={props.savePoint}
                fileSelect={props.fileSelect}
                fileChange={props.fileChange}
                handlerText={props.handlerText}
                saveCustomPin={props.saveCustomPin}
              />
          }
        </div>
      </div>
    </>
  )
}

export default Points;